export function getPreferredLaneDescription(lane) {
  return lane && `${lane.origin?.description} → ${lane.destination?.description}`
}

export function showPreferredLane(userIsLoggedIn, isLoadTaken, lane) {
  return userIsLoggedIn && !isLoadTaken && lane
}

export default { getPreferredLaneDescription, showPreferredLane }
